import { currenciesSlice } from "./currenciesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = currenciesSlice;
const moduleUrl = '/api/settings/defaultCurrencies';
const refineDataForEdit = (data: any) => {
  if (!data) return data;
  return data.items[0];
};

export const setValidationErrors = actions.setValidationErrors;

export const getItemForEdit = () => defaultActions.getItem(`${moduleUrl}`, actions, refineDataForEdit);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);

export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
